import { useNavigate, useLocation, Link } from 'react-router-dom';
import { clearToken } from '../lib/api';
import VerifyEmailBanner from './VerifyEmailBanner';

const navItems = [
  { path: '/', label: 'Projects' },
  { path: '/account', label: 'Account' },
  { path: '/billing', label: 'Billing' },
];

export default function DashboardLayout({ children }: { children: React.ReactNode }) {
  const navigate = useNavigate();
  const location = useLocation();

  return (
    <div className="min-h-screen bg-slate-950 text-slate-100">
      <VerifyEmailBanner />
      <header className="border-b border-slate-800 px-6 py-4 flex items-center justify-between">
        <div className="flex items-center gap-6">
          <Link to="/" className="text-lg font-display font-bold tracking-tight">
            <span className="bg-gradient-to-r from-emerald-400 to-cyan-400 bg-clip-text text-transparent">QuickTL</span>
          </Link>
          <nav className="flex gap-1">
            {navItems.map(item => (
              <Link
                key={item.path}
                to={item.path}
                className={`px-3 py-1 text-sm rounded-md transition-colors ${
                  location.pathname === item.path || (item.path === '/' && location.pathname.startsWith('/projects/'))
                    ? 'bg-slate-800 text-slate-100'
                    : 'text-slate-400 hover:text-slate-200'
                }`}
              >
                {item.label}
              </Link>
            ))}
          </nav>
        </div>
        <button
          onClick={() => { clearToken(); navigate('/login'); }}
          className="text-sm text-slate-400 hover:text-slate-200 transition-colors"
        >
          Sign out
        </button>
      </header>
      <main className="max-w-4xl mx-auto px-6 py-8">{children}</main>
    </div>
  );
}
